import { INewDocuments } from '@/interfaces/common.model';
import Button from '../ui/Button';
import PrimaryInput from '../ui/PrimaryInput';
import FieldLayout from '../Layout/FieldLayout';
import { useFormContext } from 'react-hook-form';
import { IDocument } from '@/interfaces/user.model';
import { EmployeeDocs, RequiredDocs } from '@/utility/enum';
import FormHead from './Form/FormHead';
interface IDocumentProps {
  docs: typeof EmployeeDocs | typeof RequiredDocs;
  newDocuments: INewDocuments[];
  existingDocuments: IDocument[];
  toggleModal: () => void;
  toggleConfirmModal: () => void;
  setSelectedId: React.Dispatch<React.SetStateAction<string | null>>;
  setNewDocuments: React.Dispatch<React.SetStateAction<INewDocuments[]>>;
  setSelectedDocument: React.Dispatch<
    React.SetStateAction<Partial<IDocument> | null>
  >;
  setDocumentError: React.Dispatch<React.SetStateAction<string>>;
}
const Document = ({
  newDocuments,
  existingDocuments,
  toggleModal,
  toggleConfirmModal,
  setSelectedId,
  setNewDocuments,
  setSelectedDocument,
  setDocumentError,
  docs,
}: IDocumentProps) => {
  const { register, watch, setValue } = useFormContext();
  const actionHandler = (id: string) => {
    setSelectedId(id);
    toggleConfirmModal();
  };
  const handleRemoveNewDocument = (key: string) => {
    setNewDocuments((prev) =>
      prev?.filter((doc) => !Object.prototype.hasOwnProperty.call(doc, key)),
    );
  };
  const handleFileChange = (key: keyof INewDocuments, file: File | null) => {
    if (!file) return;
    setNewDocuments((prev) =>
      prev?.map((doc) => (doc[key] !== undefined ? { [key]: file } : doc)),
    );
    if (key == 'Company_Logo') {
      setDocumentError('');
    }
  };
  const handleDocumentClick = (item: IDocument | INewDocuments) => {
    if ('url' in item && typeof item.url === 'string') {
      setSelectedDocument({
        url: item.url,
        name: item.name,
      });
    } else {
      const file = Object.values(item)[0];
      if (file instanceof File) {
        setSelectedDocument(file);
      }
    }

    toggleModal();
  };

  const handleAddDocument = () => {
    const docType = watch('documentType');
    if (!docType) return;
    const selectedDocument = watch('documentType') as keyof INewDocuments;
    if (!selectedDocument) return;
    if (
      selectedDocument &&
      !newDocuments?.some((doc) => doc[selectedDocument]) &&
      !existingDocuments.some((doc) => doc?.name === selectedDocument)
    ) {
      setNewDocuments((prev) => [...prev, { [selectedDocument]: null }]);
      setValue('documentType', null);
    }
  };

  return (
    <>
      {' '}
      <div className="row">
        <FormHead heading="Documents" />
        {/* {/ Document Selector /} */}
        <FieldLayout fieldStyle="col-12 col-lg-6">
          {/* <Label id="documentType">Select Documents</Label> */}
          <select
            className="form-select form-control "
            {...register('documentType')}
          >
            <option value="" className="d-none">
              Select documents
            </option>
            {Object.values(docs).map((doc) => {
              const key = doc as keyof INewDocuments;
              return (
                <option
                  key={doc}
                  value={doc}
                  disabled={
                    newDocuments.some((d) => d[key]) ||
                    existingDocuments.some((d) => d.name === doc)
                  }
                >
                  {doc.replace(/_/g, ' ')}
                </option>
              );
            })}
          </select>
        </FieldLayout>
        <FieldLayout fieldStyle="align-self-end col-lg-6">
          {' '}
          <Button
            className={'btn btn-outline-primary px-4 '}
            type="button"
            disabled={!watch('documentType')}
            onClick={handleAddDocument}
          >
            Add
          </Button>
        </FieldLayout>
      </div>
      <div className="row">
        {existingDocuments?.map((doc) => (
          <div
            key={doc.id}
            className="col-12 col-md-6 col-lg-4 mt-3 mb-5 d-flex justify-content-between align-items-center"
          >
            <h4
              className="mb-0 me-2 "
              style={{ cursor: 'pointer' }}
              role="button"
              title="View Document"
              onClick={() => handleDocumentClick(doc)}
            >
              {doc?.name && doc?.name.replace(/_/g, ' ')}
            </h4>
            <Button
              type="button"
              className="btn btn-sm btn-danger "
              onClick={() => actionHandler(doc.id ?? '')}
            >
              Delete
            </Button>
          </div>
        ))}
      </div>
      {/* {/ New Documents /} */}
      <div className="row">
        {newDocuments?.map((doc, index) => {
          const key = Object.keys(doc)[0] as keyof INewDocuments;
          const acceptType =
            key === 'Company_Logo' ||
            key == EmployeeDocs?.Aadhar_Card ||
            EmployeeDocs.Other_Documents == key ||
            EmployeeDocs.Pan_Card == key ||
            EmployeeDocs.Reliving_Letter == key;
          return (
            <div key={index} className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4
                  className={doc?.[key] ? 'mb-0 me-2' : 'mb-2 fs-5'}
                  role="button"
                  title="View Document"
                  onClick={() => handleDocumentClick(doc)}
                >
                  {key.replace(/_/g, ' ')}
                </h4>
                <Button
                  type="button"
                  className="btn btn-sm btn-danger "
                  onClick={() => handleRemoveNewDocument(key)}
                >
                  Remove
                </Button>
              </div>
              {!doc?.[key] && (
                <div className="img-uploader">
                  <PrimaryInput
                    type="file"
                    accept={acceptType ? 'image/*' : '.pdf'}
                    className="form-control"
                    onChange={(e) => {
                      if (!e?.target?.files) return;
                      const file = e.target.files[0];
                      const isImage = file.type.startsWith('image/');
                      if (isImage && file.size > 10 * 1024 * 1024) {
                        setDocumentError('Image size cannot exceed 10 MB');
                        e.target.value = '';
                        return;
                      }
                      handleFileChange(key, e.target.files[0]);
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};
export default Document;
